package com.eladfinish.bible.contest.screens.search.history

import com.eladfinish.bible.contest.screens.search.mvi.SearchState
import com.eladfinish.bible.contest.screens.search.usecases.engine.model.PrepareLocalSearchRequestResult

/**
 * Records a search the moment it starts. A click that doesn't start a search (an invalid
 * expression, a "did you mean" suggestion, a debug code) is not history; a search that is later
 * stopped still is, which is why nothing about its outcome is involved here.
 */
class RecordSearchHistoryUseCase(
    private val searchHistoryRepository: SearchHistoryRepository,
) {

    suspend operator fun invoke(
        state: SearchState,
        prepareResult: PrepareLocalSearchRequestResult,
    ): SearchHistoryEntry? {
        if (!prepareResult.startsSearch()) return null

        return searchHistoryRepository.record(state.toSearchHistoryKey())
    }
}

fun PrepareLocalSearchRequestResult.startsSearch(): Boolean =
    when (this) {
        is PrepareLocalSearchRequestResult.Ready,
        is PrepareLocalSearchRequestResult.ExecuteSpecial,
        -> true

        is PrepareLocalSearchRequestResult.Error,
        is PrepareLocalSearchRequestResult.SuggestAlternative,
        is PrepareLocalSearchRequestResult.DebugMessage,
        PrepareLocalSearchRequestResult.ToggleDebugUser,
        -> false
    }
